module.exports = __webpack_public_path__ + "assets/img/domains.0d7573e9.svg";